module.exports = __webpack_public_path__ + "img/do-poprawy.3e527a3f.svg";